import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const ExpiryDialog = ({ open, onOpenChange, selectedDriver, expiryData, setExpiryData, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Document Expiry Dates</DialogTitle>
        <DialogDescription>
          Set expiry dates for {selectedDriver?.driver_name}'s documents
        </DialogDescription>
      </DialogHeader>
      <form onSubmit={onSubmit}>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="license_expiry">Driver's License Expiry</Label>
            <Input
              id="license_expiry"
              type="date"
              value={expiryData.license_expiry?.split('T')[0] || ''}
              onChange={(e) => setExpiryData({ ...expiryData, license_expiry: e.target.value })}
              data-testid="license-expiry-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="pdp_expiry">PDP Expiry</Label>
            <Input
              id="pdp_expiry"
              type="date"
              value={expiryData.pdp_expiry?.split('T')[0] || ''}
              onChange={(e) => setExpiryData({ ...expiryData, pdp_expiry: e.target.value })}
              data-testid="pdp-expiry-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="vehicle_docs_expiry">Vehicle Documents Expiry</Label>
            <Input
              id="vehicle_docs_expiry"
              type="date"
              value={expiryData.vehicle_docs_expiry?.split('T')[0] || ''}
              onChange={(e) => setExpiryData({ ...expiryData, vehicle_docs_expiry: e.target.value })}
              data-testid="vehicle-docs-expiry-input"
            />
          </div>
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button type="submit" data-testid="save-expiry-button">Save Expiry Dates</Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);
